import { useTranslations } from '../../../../../hooks/useTranslations';
import Chevron, { Direction } from '../../../../ui/icons/Chevron/Chevron';
import { SmallHeader } from '../../../../ui/Header/Header';
import useOrderTracking from '../../../../../hooks/useOrderTracking';
import { useTrackQualityCarrierLogo } from '../../CarrierTrackingLink/hooks/useTrackQualityCarrierLogo';
import styles from './ShippingHistoryToggle.module.css';

interface ShippingHistoryToggleProps {
  collapsed: boolean;
  onClick: () => void;
}

function ShippingHistoryToggle({
  collapsed,
  onClick,
}: ShippingHistoryToggleProps) {
  const {
    shippingActivityGenericHeaderText,
    shippingActivityLatestUpdateText,
  } = useTranslations();

  const { getCurrentShipment } = useOrderTracking();
  const currentShipment = getCurrentShipment();
  const { carrierLogoUrl, carrier } = currentShipment ?? {};

  const { ref: imgRef, clientCarrierLogo } =
    useTrackQualityCarrierLogo(currentShipment);

  const handleClick = () => {
    onClick();
  };

  return (
    <div className={styles.clickContainer} onClick={handleClick}>
      <div style={{ display: 'flex', alignItems: 'center', margin: 0 }}>
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '2.5rem',
            paddingRight: '0.5rem',
          }}
        >
          <img
            ref={imgRef}
            // `carrierLogoUrl` is nullable on the orderTracking query because of
            // scenarios like preship and bopis. However, it will be populated with
            // at least a the generic logo url in every other case.
            src={clientCarrierLogo ?? carrierLogoUrl ?? ''}
            alt={`${carrier ?? ''}`}
            style={{
              maxHeight: '2.5rem',
            }}
          />
        </span>
        <SmallHeader
          as="h3"
          containerCustomStyle={{
            display: 'inline-block',
            marginRight: '0.5rem',
          }}
        >
          {collapsed
            ? shippingActivityLatestUpdateText
            : shippingActivityGenericHeaderText}
        </SmallHeader>
      </div>
      <div>
        <div role="button" tabIndex={-1}>
          <Chevron
            direction={Direction.Up}
            s={{
              color: 'currentColor',
              fill: 'currentColor',
              paddingBottom: '0.25rem',
              transform: `${collapsed ? `rotate(180deg)` : `none`}`,
              transformOrigin: 'center center',
              width: '0.875rem',
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default ShippingHistoryToggle;
